import mediaQueries from 'styles/mediaQueries';
import mediaQueryBuilder from 'styles/helpers/mediaQueryBuilder';
import styled from '@emotion/styled';
import Time from 'widget/components/Progress/primitives/Time';

type Props = {
  notYetInteractedWith?: boolean;
  supportMobileView: boolean;
  'data-test'?: string;
  hide?: boolean;
};

const Container = styled('div')<Props>(({
  notYetInteractedWith = true,
  supportMobileView = false,
  hide = false,
}) => {
  let marginString;

  if (supportMobileView) {
    if (notYetInteractedWith) {
      marginString = '0 .2rem';
    } else {
      marginString = '0 .2rem 0 8.5rem';
    }
  } else {
    marginString = '0 9rem 0 8.5rem';
  }

  return {
    margin: marginString,
    position: 'relative',
    visibility: hide ? 'hidden' : 'visible',

    [mediaQueryBuilder(mediaQueries.max.height['399'])]: {
      margin: '0 7.5rem 0 6.5rem',
    },
    [mediaQueryBuilder(
      mediaQueries.max.height['199'],
      mediaQueries.max.width['299'],
    )]: {
      margin: '0 6.5rem 0 5.5rem',
    },
    [mediaQueryBuilder(
      mediaQueries.max.height['119'],
      mediaQueries.max.width['199'],
    )]: {
      display: 'none',
    },

    [Time.toString()]: {
      '&:first-of-type': {
        left: 0,
        top: 0,
      },

      '&:last-of-type': {
        right: '1rem',
        top: 0,
      },
    },
  };
});

export default Container;
